import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TheBorder} from "../TheBorder";
import {TimelineMax} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayUtils} from "../utils/ArrayUtils";
import {TheBorderStatics} from "../TheBorderStatics";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/ReelInterfaces";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderNormalResultPresentation implements FlowStatePresentation {

    protected _tl: TimelineMax;
    protected _stoppedReels: boolean[];

    public start(flowStateController: FlowStateController): void {
        this._stoppedReels = [false, false, false, false, false, false];
        let luckyDrawDuration: number = 0;

        this._tl = new TimelineMax();

        this._tl.add(() => flowStateController.setSkipCallback(() => this.skip()), 0.1);

        const mainReelStopDelay = TheBorder.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TheBorderStatics.mainReelAllInStopDelayFastSpin : TheBorderStatics.mainReelAllInStopDelay,
            reels: string[][] = TheBorder.model.gameData.reels,
            nearWinReels: boolean[] = TheBorder.model.nearWinReels;
        let stopTime: number = 0,
            nearWinDelay: number = 0;
        for (let i: number = 0; i < reels.length; i++) {
            const reelStopAnimation: TimelineMax = new TimelineMax({delay: luckyDrawDuration});

            reelStopAnimation.add(TheBorder.allReelsView.mainReelModels[i].stop(reels[i]));

            if (nearWinReels[i + 1]) {
                reelStopAnimation.add(() => {
                    TheBorder.reelHighlighter.highlightReel(i + 1);
                });
            }

            stopTime += nearWinDelay;

            TheBorder.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data: SimpleReelModelEventData) => this.onReelStop(data, flowStateController));

            this._tl.add(reelStopAnimation, stopTime);
            stopTime += mainReelStopDelay;

            if (nearWinReels[i + 1]) {
                nearWinDelay = 2.5;
            }
        }

        const padding = TheBorder.gameFlowController.calculatePaddingDuration(this._tl.totalDuration() - 0.1);
        if (padding > 0) {
            this._tl.shiftChildren(padding);
        }
    }

    protected onReelStop(data: SimpleReelModelEventData, flowStateController: FlowStateController) {
        this._stoppedReels[data.reel] = true;
        if (ArrayUtils.isAllTrue(this._stoppedReels)) {
            TheBorder.reelHighlighter.stopHighlight();
            this.completePresentation(flowStateController);
        }
    }

    protected skip(): void {
        if (this._tl) {
            this._tl.totalProgress(1);
        }
    }

    private completePresentation(flowStateController: FlowStateController) {
        flowStateController.finish();
    }
}